import {HasTenantResource, ResourceConfig} from "@hidat/huijs-resource";
import {FieldConfig, FieldDataTypes, nNumber, nString, uNumber, Uuid} from "@hidat/huijs-common";
import {LocalDate} from "@js-joda/core";
import {RblFieldConfigs, RblTenantResourceInterface} from "../rbl-resource.interface";

export const LibraryItemFields = {
  usageCode: new FieldConfig('usageCode'),
  shortCode: new FieldConfig('shortCode'),
  rotationStatus: new FieldConfig('rotationStatus', FieldDataTypes.NUMBER),
  firstUsedDate: new FieldConfig('firstUsedDate', FieldDataTypes.DATE),
  lastUsedDate: new FieldConfig('lastUsedDate', FieldDataTypes.DATE).setEditable(false),
  lastChangedDate: new FieldConfig('lastChangedDate', FieldDataTypes.DATE).setEditable(false),
}

export const LibraryItemMetaFields = {
  category: new FieldConfig('category', FieldDataTypes.STRING, true, 'SCHEDULING_CATEGORY'),
  secondaryCategory: new FieldConfig('secondary_category', FieldDataTypes.STRING, true, 'SECONDARY_SCHEDULING_CATEGORY'),
  nameKeyword: new FieldConfig('name_keyword'),
  artistKeyword: new FieldConfig('artist_keyword'),
  schedulingNotes: new FieldConfig('scheduling_notes')
}

export const LibraryItemConfig = new ResourceConfig('LibraryItem', 'library_items', true, true)
  .addFields([
    RblFieldConfigs.id,
    RblFieldConfigs.status,
    RblFieldConfigs.uid,
    RblFieldConfigs.library,
    RblFieldConfigs.libraryTitle,
    RblFieldConfigs.title,
    RblFieldConfigs.repoAssetId,
    new FieldConfig('mediaInfo', FieldDataTypes.HASH),
    new FieldConfig('metaExtended', FieldDataTypes.HASH),
  ])
  .addFields(Object.values(LibraryItemFields))
  .setSorts({
    createdat: 'createdAt'
  })
  .setDefaultSort('createdat')

export interface LibraryItemPreviewAssets {
  aac_preview?: number;
  mp3_preview?: number;
  ogg_preview?: number;
  mp3_download?: number;
}

export interface LibraryItemAudioAnalysis {
  dynamics?: number;
  average_rms?: number;
  intro_length?: number;
  start_silence?: number;
  start_quiet?: number;
  outro_length?: number;
  outro_silence?: number;
  outro_quiet?: number;
}

export interface LibraryItemMediaInfo {
  duration?: number;
  preview_assets?: LibraryItemPreviewAssets;
  audio_analysis?: LibraryItemAudioAnalysis;
}

export interface LibraryItemMetaExtended {
  category?: string;
  secondary_category?: string;
  name_keyword?: string;
  artist_keyword?: string;
  scheduling_notes?: string;
}

export interface LibraryItemInterface extends RblTenantResourceInterface, HasTenantResource {
  uid: Uuid | undefined;
  libraryId: uNumber;
  libraryTitleId: uNumber;
  titleId: uNumber;
  repoAssetId: uNumber;

  usageCode: nString;
  shortCode: nString;
  mediaInfo: LibraryItemMediaInfo | undefined;
  metaExtended: LibraryItemMetaExtended | undefined;

  rotationStatus: nNumber;
  firstUsedDate: LocalDate | undefined | null;
  lastUsedDate: LocalDate | undefined | null;
  lastChangedDate: LocalDate | undefined | null;

}
